'use strict';

var triggerCustomEvent = require('trigger-custom-event');

var appDom = require('./app-dom');
var formWidget = require('./form-widget');
var autoSize = require('./auto-size');
var customLink = require('./custom-link');
var focalPoint = require('./focal-point');
var close = require('./close');
var track = require('./track');
var video = require('./video');

var data;

var show = function() {

	appDom.iframe
		.css({
			transition: 'opacity .2s',
			opacity: 1,
			'pointer-events': 'auto'
		})
		.addClass('promo--is-active');

	triggerCustomEvent('promo-opened', {
		target: appDom.promo
	});

};

var onWindowLoad = function() {

	if (data.triggerDelay && !data.previewMode) {

		setTimeout(show, data.triggerDelay);

	} else {

		show();

	}

};

var init = function(d) {

	data = d;

	appDom.init(data);
	autoSize.init(data);
	formWidget.init();
	focalPoint.init();
	video.init();

	if (!data.previewMode) {

		close.init();
		customLink.init();
		track.init(data);

	}

	appDom.window.on('load', onWindowLoad);

};

module.exports = {
	init: init
};
